import { BrowserRouter, Routes, Route, Navigate, useParams } from "react-router-dom";
import { useAuthContext } from "./hooks/useAuthContext";

// pages & components
import Login from "./pages/login/Login";
import Signup from "./pages/signup/Signup";
import Home from "./pages/home/Home";
import Navbar from "./components/Navbar";
import { useCollection } from "./hooks/useCollection";
import Lending from "./pages/lending/Lending";
import ContactTransaction from "./pages/contact/ContactTransaction";
require('dotenv').config();
function App() {
  const { authIsReady, user } = useAuthContext();

  return (
    <div className="App">
      {authIsReady && (
        <BrowserRouter>
           <Navbar />
          <Routes>
            <Route
              path="/"
              element={user ? <Home /> : <Navigate to="/login" />}
            />
            <Route
              path="/lending"
              element={user ? <Lending /> : <Navigate to="/login" />}
            />
            <Route
              path="/login"
              element={user ? <Navigate to="/" /> : <Login />}
            />
            <Route
              path="/pranaypisesignup"
              element={user ? <Navigate to="/" /> : <Signup />}
            />
            <Route path='/:uid/:contactId' element={<ContactTransaction />} />
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </BrowserRouter>
      )}
    </div>
  );
}

export default App;
